import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import PersonalHubSummary from "../PageApps/PersonalHubSummary";
import Div100vh from "react-div-100vh/lib/Div100vh";
import TopNavbar from "../topNavbar/TopNavbar";
import PageHeader from "../../pages/pageHeader/PageHeader";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { HOST_URL } from "../../helpers/constants/Constants";
import MiniViewer from "../viewer/MiniViewer";
import Viewer from "../viewer/Viewer";
import store from "../../helpers/store/Store";
import {
  getSelectedModelArray,
  getSelectedModel,
  getSelectedProject,
  getReviewId,
  update,
} from "../../helpers/actions/Action";
import ProjectNavbar from "../projectNavbar/ProjectNavbar";
import { useHistory } from "react-router-dom";

const PersonalHubPage = () => {
  //Reducers-----------------------------
  const userData = useSelector((state) => state.requestUserDataReducer.data);
  const selectedModel = useSelector(
    (state) => state.getSelectedModelReducer.data
  );
  const reviewId = useSelector((state) => state.getPersonalHubReducer.reviewId);
  const modelArry = useSelector((state) => state.requestUserDataReducer.data);
  const projectData = useSelector(
    (state) => state.requestProjectsDataReducer.data
  );
  //-------------------------------------

  //localVariable-----------------------------
  const [initialLoad, setIntialLoad] = useState(true);
  const history = useHistory();
  const [workflows, setWorkflows] = useState();
  const [pendingWorkflowReviews, setPendingWorkflowReviews] = useState();
  const [pendingWorkflowApprovals, setPendingWorkflowApprovals] = useState();
  const [markups, setMarkups] = useState();
  const [pendingMarkups, setPendingMarkups] = useState();
  const [pendingDsears, setPendingDsears] = useState();

  const [selectedWorkflow, setSelectedWorkflow] = useState();
  const [viewSelected, setViewSelected] = useState(false);
  const [comment, setComment] = useState();
  const [selectedDsear, setSelectedDsear] = useState();

  const [myWorkflowFilter, setMyWorkflowFilter] = useState({});
  const [myPendingWorkflowReviews, setPendingWorkflowReviewFilter] = useState(
    {}
  );
  const [myPendingWorkflowApprovals, setPendingWorkflowApprovalsFilter] =
    useState({});
  const [myMarkupsFilter, setMyMarkupsFilter] = useState({});
  const [myMarkupsReview, setMyMarkupsReviewFilter] = useState({});
  const [myPendingDsear, setMyPendingDsearFilter] = useState({});
  //-------------------------------------

  //Input Handlers--------------------------
  const commentInputHandler = (e) => {
    setComment(e.target.value);
  };

  const handleFilterDataUpdate = (e, context, type) => {
    switch (context) {
      case "myWorkflowFilter":
        var temp = {
          ...myWorkflowFilter,
          [type]: e.target.value,
        };
        setMyWorkflowFilter(temp);
        break;
      case "myPendingWorkflowReviews":
        var temp = {
          ...myPendingWorkflowReviews,
          [type]: e.target.value,
        };
        setPendingWorkflowReviewFilter(temp);
        break;
      case "myPendingWorkflowApprovals":
        var temp = {
          ...myPendingWorkflowApprovals,
          [type]: e.target.value,
        };
        setPendingWorkflowApprovalsFilter(temp);
        break;
      case "myMarkupsFilter":
        var temp = {
          ...myMarkupsFilter,
          [type]: e.target.value,
        };
        setMyMarkupsFilter(temp);
        break;
      case "myMarkupsReview":
        var temp = {
          ...myMarkupsReview,
          [type]: e.target.value,
        };
        setMyMarkupsReviewFilter(temp);
        break;
      case "myPendingDsear":
        var temp = {
          ...myPendingDsear,
          [type]: e.target.value,
        };
        setMyPendingDsearFilter(temp);
        break;
    }
  };

  const filterWorkflow = (workflow, filter) => {
    if (
      (filter.projectName == null ||
        filter.projectName == "" ||
        workflow.projectName
          ?.toLowerCase()
          .includes(filter.projectName.toLowerCase())) &&
      (filter.documentName == null ||
        filter.documentName == "" ||
        workflow.documentName
          ?.toLowerCase()
          .includes(filter.documentName.toLowerCase())) &&
      (filter.uploadFolderName == null ||
        filter.uploadFolderName == "" ||
        workflow.uploadFolderName
          ?.toLowerCase()
          .includes(filter.uploadFolderName.toLowerCase())) &&
      (filter.createdDate == null ||
        filter.createdDate == "" ||
        workflow.createdDate
          ?.toLowerCase()
          .includes(filter.createdDate.toLowerCase())) &&
      (filter.comment == null ||
        filter.comment == "" ||
        workflow.comment
          ?.toLowerCase()
          .includes(filter.comment.toLowerCase())) &&
      (filter.status == null ||
        filter.status == "" ||
        workflow.status?.toLowerCase().includes(filter.status.toLowerCase()))
    ) {
      return workflow;
    }
  };
  const filterMarkup = (markup, filter) => {
    if (
      (filter.title == null ||
        filter.title == "" ||
        markup.title?.toLowerCase().includes(filter.title.toLowerCase())) &&
      (filter.projectName == null ||
        filter.projectName == "" ||
        markup.projectName
          ?.toLowerCase()
          .includes(filter.projectName.toLowerCase())) &&
      (filter.document == null ||
        filter.document == "" ||
        markup.documentName
          ?.toLowerCase()
          .includes(filter.document.toLowerCase())) &&
      (filter.createdDate == null ||
        filter.createdDate == "" ||
        markup.createdDate
          ?.toLowerCase()
          .includes(filter.createdDate.toLowerCase()))
    ) {
      return markup;
    }
  };
  const filterDsear = (dsear, filter) => {
    if (
      (filter.projectName == null ||
        filter.projectName == "" ||
        dsear.projectName
          ?.toLowerCase()
          .includes(filter.projectName.toLowerCase())) &&
      (filter.createdDate == null ||
        filter.createdDate == "" ||
        dsear.createdDate
          ?.toLowerCase()
          .includes(filter.createdDate.toLowerCase()))
    ) {
      return dsear;
    }
  };

  useEffect(() => {
    // debugger;
    // var model = ''
    // store.dispatch(getSelectedModel(model));
    // Workflows ----------------------------------------------
    axios({
      method: "Get",
      url: HOST_URL + "/api/workflow/created?id=" + userData.id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setWorkflows(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios({
      method: "Get",
      url: HOST_URL + "/api/workflow/pendingReview?id=" + userData.id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setPendingWorkflowReviews(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios({
      method: "Get",
      url: HOST_URL + "/api/workflow/pendingApproval?id=" + userData.id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setPendingWorkflowApprovals(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Markups ----------------------------------------------

    axios({
      method: "Get",
      url: HOST_URL + "/api/markup/created?id=" + userData.id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setMarkups(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios({
      method: "Get",
      url: HOST_URL + "/api/markup/pending?id=" + userData.id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("Markup Pending - ", response.data);
        setPendingMarkups(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
debugger;
    // Dsear ----------------------------------------------
    axios({
      method: "Get",
      url: HOST_URL + "/api/dsear/pendingApproval?email=" + userData.email,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setPendingDsears(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (selectedModel.selected === true && initialLoad != true) {
      history.replace("/main");
    }
  }, [selectedModel]);

  useEffect(() => {
    if (selectedDsear != null && initialLoad != true) {
      // history.replace("/dsear");
    }
  }, [selectedDsear]);

  const handleReviewButtonClick = (e, status) => {
    let formData = new FormData();
    formData.append(
      "formData",
      JSON.stringify({
        id: e.target.value,
        reviewerId: userData.id,
        comment: comment,
        status: status,
      })
    );

    axios({
      method: "Put",
      url: HOST_URL + "/api/workflow/UpdateReview",
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        alert(response.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectWorkflow = (e) => {
    axios({
      method: "Get",
      url: HOST_URL + "/api/workflow?id=" + e.target.value,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setSelectedWorkflow(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectViewWorkflowModel = (e, reviewMode) => {
    var workflowId = e.target.value;
    axios({
      method: "Get",
      url: HOST_URL + "/api/workflow?id=" + workflowId,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setIntialLoad(false);
        var data = response.data;
        store.dispatch(update("docId", data.itemId));
        if (reviewMode == "Review") {
          store.dispatch(update("reviewId", workflowId));
        }
        if (reviewMode == "Approval") {
          store.dispatch(update("approvalId", workflowId));
        }

        var viewerModel = {
          id: data.itemId,
          name: data.documentName,
          number: Math.random(),
          selected: true,
          //The selected model and model array are different structures
          //Adding these fixes the issue of creating a workflow from view
          hrefbim360: "href/"+data.documentId,
          fileName: data.documentName,
        };
        var arrayModel = [];
        arrayModel.push(viewerModel);
        store.dispatch(getSelectedModel(viewerModel));
        store.dispatch(getSelectedModelArray(arrayModel));
        //I may need to load the projects as ProjectData may be null
        var modelProject = projectData.find(
          (o) => o.projectid == data.projectId
        );
        store.dispatch(getSelectedProject(modelProject));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectMarkup = (e) => {
    axios({
      method: "Get",
      url: HOST_URL + "/api/markups?id=" + e.target.value,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setSelectedWorkflow(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectViewMarkupModel = (e) => {
    var markupId = e.target.value;
    axios({
      method: "Get",
      url: HOST_URL + "/api/markup?id=" + markupId,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setIntialLoad(false);
        debugger;
        var data = response.data;
        const viewerModel = {
          id: data.itemId,
          name: data.documentName,
          number: Math.random(),
          selected: true,
          //The selected model and model array are different structures
          //Adding these fixes the issue of creating a workflow from view
          hrefbim360: "href/"+data.documentId,
          fileName: data.documentName,
        };
        var arrayModel = [];
        arrayModel.push(viewerModel);
        store.dispatch(getSelectedModelArray(arrayModel));
        store.dispatch(getSelectedModel(viewerModel));
        //I may need to load the projects as ProjectData may be null
        var modelProject = projectData.find(
          (o) => o.projectid == data.projectId
        );
        store.dispatch(getSelectedProject(modelProject));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const selectViewDsear = (e) => {
    setIntialLoad(false);
    store.dispatch(update("dsearId", e.target.value));
    history.replace("/dsear");
  };

  return (
    <div style={{ overflowY: "auto" }}>
      <Div100vh>
        {/* <ProjectNavbar></ProjectNavbar> */}
        <TopNavbar />
        {/* <section id="theContent">
          <div id="theMainContent" className="theProjectViewer">
            <section id="sectionClass" style={{   height: "calc(100% - 100px)"}}>
            <div>Control Panel</div>
          <Viewer urn={"urn:"+viewerModel.id} id={viewerModel.id} model={viewerModel} />
          </section>
          </div>
        </section> */}
        <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader>
        <PersonalHubSummary name={userData.name} />
        <br />
        <br />
        <br />
        <br />
        <br />
        {/* {workflows? <p>{workflows}</p>:<></>} */}
        <div className="p-4">
          <ul class="nav nav-tabs">
            <li class="active">
              <a class="active" data-toggle="tab" href="#workflow">
                Worflows
              </a>
            </li>

            <li>
              <a data-toggle="tab" href="#markup">
                Markups
              </a>
            </li>

            <li>
              <a data-toggle="tab" href="#dsear">
                DSEAR
              </a>
            </li>
          </ul>

          <div class="tab-content">
            {/* Workflow------------------------------------------------------------------------------ */}
            <div id="workflow" class="tab-pane fade mb-1 mt-1 active show">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    data-toggle="tab"
                    href="#myWorkflows">
                    My Worflows
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#workflowsReview">
                    Pending Review
                  </a>
                </li>

                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="tab"
                    href="#workflowsApproval">
                    Pending Approval
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                {/* My Workflows */}
                <div
                  id="myWorkflows"
                  class="tab-pane fade mb-1 mt-1  active show">
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProjectName"
                            placeholder="Project Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "projectName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterDocumentName"
                            placeholder="Document Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "documentName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterTargetFolder"
                            placeholder="Target Folder"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "targetFolder"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreatedDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterComment"
                            placeholder="Comment"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "comment"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterStatus"
                            placeholder="Status"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myWorkflowFilter",
                                "status"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Project</th>
                        <th scope="col">Document</th>
                        <th scope="col">Target Folder</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">Comment</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workflows?.map((workflow, i) => {
                        if (filterWorkflow(workflow, myWorkflowFilter)) {
                          return (
                            <tr>
                              <td>{workflow.projectName}</td>
                              <td>
                                <span className="p-2">
                                  {workflow.documentName}
                                </span>
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary mr-2"
                                  data-toggle="modal"
                                  data-target="#inspectWorkflowModal"
                                  onClick={(e) => selectWorkflow(e)}>
                                  Inspect
                                </button>
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={(e) =>
                                    selectViewWorkflowModel(e, null)
                                  }>
                                  View
                                </button>
                              </td>
                              <td>{workflow.uploadFolderName}</td>
                              <td>{workflow.createdDate}</td>
                              <td>{workflow.comment}</td>
                              <td>{workflow.status}</td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
                {/* My Workflows Pending Review */}
                <div
                  id="workflowsReview"
                  class="tab-pane fade mb-1 mt-1">
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProjectName"
                            placeholder="Project Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "projectName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterDocumentName"
                            placeholder="Document Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "documentName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterTargetFolder"
                            placeholder="Target Folder"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "targetFolder"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreatedDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterComment"
                            placeholder="Comment"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "comment"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterStatus"
                            placeholder="Status"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowReviews",
                                "status"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        {/* <th scope="col">#</th> */}
                        <th scope="col">Project</th>
                        <th scope="col">Document</th>
                        <th scope="col">Target Folder</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">Comment</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingWorkflowReviews?.map((workflow, i) => {
                        if (
                          filterWorkflow(workflow, myPendingWorkflowReviews)
                        ) {
                          return (
                            <tr>
                              <td>{workflow.projectName}</td>
                              <td>
                                {workflow.documentName}
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary mx-2"
                                  data-toggle="modal"
                                  data-target="#inspectWorkflowModal"
                                  onClick={(e) => selectWorkflow(e)}>
                                  Inspect
                                </button>
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={(e) =>
                                    selectViewWorkflowModel(e, "Review")
                                  }>
                                  Review
                                </button>
                              </td>
                              <td>{workflow.uploadFolderName}</td>
                              <td>{workflow.createdDate}</td>
                              <td>{workflow.comment}</td>
                              <td>{workflow.status}</td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
                {/* My Workflows Pending Approval */}
                <div
                  id="workflowsApproval"
                  class="tab-pane fade mb-1 mt-1">
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProjectName"
                            placeholder="Project Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "projectName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterDocumentName"
                            placeholder="Document Name"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "documentName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterTargetFolder"
                            placeholder="Target Folder"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "targetFolder"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreatedDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterComment"
                            placeholder="Comment"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "comment"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterStatus"
                            placeholder="Status"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingWorkflowApprovals",
                                "status"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        {/* <th scope="col">#</th> */}
                        <th scope="col">Project</th>
                        <th scope="col">Document</th>
                        <th scope="col">Target Folder</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">Comment</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingWorkflowApprovals?.map((workflow, i) => {
                        if (
                          filterWorkflow(workflow, myPendingWorkflowReviews)
                        ) {
                          return (
                            <tr>
                              <td>{workflow.projectName}</td>
                              <td>
                                {workflow.documentName}
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary mx-2"
                                  data-toggle="modal"
                                  data-target="#inspectWorkflowModal"
                                  onClick={(e) => selectWorkflow(e)}>
                                  Inspect
                                </button>
                                <button
                                  value={workflow.id}
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={(e) =>
                                    selectViewWorkflowModel(e, "Approval")
                                  }>
                                  Approve
                                </button>
                              </td>
                              <td>{workflow.targetFolder}</td>
                              <td>{workflow.createdDate}</td>
                              <td>{workflow.comment}</td>
                              <td>{workflow.status}</td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Markups------------------------------------------------------------------------------ */}
            <div id="markup" class="tab-pane fade mb-1 mt-1">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    data-toggle="tab"
                    href="#myMarkups">
                    My Markups
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#markupsReview">
                    Pending Review
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div id="myMarkups" class="tab-pane fade mb-1 mt-1  active show">
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterTitle"
                            placeholder="Title"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsFilter",
                                "title"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProject"
                            placeholder="Project"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsFilter",
                                "projectName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterDocument"
                            placeholder="Document"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsFilter",
                                "document"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreatedDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsFilter",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Project</th>
                        <th scope="col">Document</th>
                        <th scope="col">Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {markups?.map((markup, i) => {
                        if (filterMarkup(markup, myMarkupsFilter)) {
                          return (
                            <tr>
                              <td>{markup.title}</td>
                              <td>{markup.projectName}</td>
                              <td>
                                <span className="p-2">
                                  {markup.documentName}
                                </span>

                                <button
                                  value={markup.id}
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={(e) =>
                                    selectViewMarkupModel(e, false)
                                  }>
                                  View
                                </button>
                              </td>
                              <td>{markup.createdDate}</td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
                <div id="markupsReview" class="tab-pane fade mb-1 mt-1">
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterTitle"
                            placeholder="Title"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsReview",
                                "title"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProject"
                            placeholder="Project"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsReview",
                                "projectName"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterDocument"
                            placeholder="Document"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsReview",
                                "document"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreatedDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myMarkupsReview",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Project</th>
                        <th scope="col">Document</th>
                        <th scope="col">Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingMarkups?.map((markup, i) => {
                        if (filterMarkup(markup, myMarkupsReview)) {
                          return (
                            <tr>
                              <td>{markup.title}</td>
                              <td>{markup.projectName}</td>
                              <td>
                                {markup.documentName}{" "}
                                <button
                                  value={markup.id}
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={(e) =>
                                    selectViewMarkupModel(e, false)
                                  }>
                                  View
                                </button>
                              </td>
                              <td>{markup.createdDate}</td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Dsear------------------------------------------------------------------------------ */}
            <div id="dsear" class="tab-pane fade mb-1 mt-1">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#dsearApproval">
                    Pending Approval
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div id="myDsear" class="tab-pane fade mb-1 mt-1  active show">
                  <table className="table">
                    <thead>
                    <tr>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterProject"
                            placeholder="Project"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingDsear",
                                "project"
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ backgroundColor: "White", border: "none" }}>
                          <input
                            className="form-control"
                            type="text"
                            id="filterCreateDate"
                            placeholder="Created Date"
                            onChange={(e) =>
                              handleFilterDataUpdate(
                                e,
                                "myPendingDsear",
                                "createdDate"
                              )
                            }
                          />
                        </th>
                      </tr>
                      <tr>
                        <th scope="col">Project</th>
                        <th scope="col">Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(pendingDsears)}
                      {pendingDsears?.map((dsear, i) => {
                        if(filterDsear(dsear,myPendingDsear)){
                        return (
                          <tr>
                            <td>
                              {dsear.projectName}
                              <button
                                value={dsear.id}
                                type="button"
                                className="btn btn-primary ml-1"
                                onClick={(e) => selectViewDsear(e, false)}>
                                View
                              </button>
                            </td>
                            <td>{dsear.createdDate}</td>
                          </tr>
                        );}
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>

          {/* Inspect Workflow Model */}
          <div
            className="modal fade"
            id="inspectWorkflowModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="inspectWorkflowModalLabel"
            aria-hidden="true">
            <div
              className="modal-dialog modal-lg"
              style={{ width: "100%", height: "100%" }}
              role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="inspectWorkflowModalLabel">
                    Workflow - {selectedWorkflow?.documentName}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="p-2" style={{ margin: "auto", width: "75%" }}>
                    <div className="row">
                      <div className="col font-weight-bold">Id</div>
                      <div className="col">{selectedWorkflow?.id}</div>
                    </div>
                    <div className="row">
                      <div className="col font-weight-bold">Created Date</div>
                      <div className="col">{selectedWorkflow?.createdDate}</div>
                    </div>
                    <div className="row">
                      <div className="col font-weight-bold">Comment</div>
                      <div className="col">{selectedWorkflow?.comment}</div>
                    </div>
                  </div>
                  <h4 className="font-weight-bold">Reviewers</h4>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col">Email</th>
                        <th scope="col">Status</th>
                        <th scope="col">Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedWorkflow?.reviewers.map((reviewer, i) => {
                        return (
                          <tr>
                            <td>{reviewer.email}</td>
                            <td>{reviewer.status}</td>
                            <td>{reviewer.comment}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h4 className="font-weight-bold">Approvers</h4>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col">Email</th>
                        <th scope="col">Status</th>
                        <th scope="col">Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedWorkflow?.approvers.map((reviewer, i) => {
                        return (
                          <tr>
                            <td>{reviewer.email}</td>
                            <td>{reviewer.status}</td>
                            <td>{reviewer.comment}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Div100vh>
    </div>
  );
};

export default PersonalHubPage;
